/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-23 13:34:13
 *
 * LastModified: 2017-06-06 13:51:12
 *-------------------------------------------------------*/

import LocalStorage from './LocalStorage'

const Auth = {
  setAuth(auth) {
    LocalStorage.setItem('auth', auth)
  },

  setBillingAgreementId(billingAgreementId) {
    LocalStorage.setItem('billingAgreementId', billingAgreementId)
  },

  removeAuth() {
    LocalStorage.removeItem('auth')
  },

  loggedIn() {
    return !!LocalStorage.getItem('auth') && !!LocalStorage.getItem('auth').token
  },

  token() {
    return LocalStorage.getItem('auth') ? LocalStorage.getItem('auth').token : null
  },

  userId() {
    return LocalStorage.getItem('auth') ? LocalStorage.getItem('auth').userId : null
  },

  s3Url() {
    return LocalStorage.getItem('auth') ? LocalStorage.getItem('auth').s3Url : null
  },

  // userType() {
  //   return LocalStorage.getItem('auth') ? LocalStorage.getItem('auth').type : null
  // },

  billingAgreementId() {
    return LocalStorage.getItem('billingAgreementId') ? LocalStorage.getItem('billingAgreementId') : null
  },

  ttl() {
    return LocalStorage.getItem('auth') ? LocalStorage.getItem('auth').ttl : 0
  },

  tokenCreatedAt() {
    return LocalStorage.getItem('auth') ? LocalStorage.getItem('auth').created : null
  },

  redirectToLogin(nextState, replace) {
    if (!Auth.loggedIn()) {
      replace({
        pathname: '/login',
        state: { nextPathname: nextState.location.pathname }
      })
    } else if (Auth.userId() === 1) {
      // admin
      replace('/admin')
    } else if (Auth.userId() === 2) {
      // marker
      replace('/admin/glasses-list')
    }
  },

  redirectAdminToLogin(nextState, replace) {
    if (!Auth.loggedIn()) {
      replace({
        pathname: '/login',
        state: { nextPathname: nextState.location.pathname }
      })
    } else if (Auth.userId() !== 1 && Auth.userId() !== 2) {
      replace('/v2/dashboard')
    }
  },

  checkLogin(nextState, replace) {
    // if (Auth.loggedIn()) {
    //   Auth.userType() === 'admin' ? replace('/admin') : replace('/')
    // }
  },

  redirectToProfile(userId) {
    if (!Auth.userId()) {
      return ''
    }
    return Auth.userId() === userId ? '/my-profile' : `/profile/${userId}`
  }
}

export default Auth



// WEBPACK FOOTER //
// ./utils/Auth.js